module.exports = __webpack_public_path__ + "static/media/icon.twitter_Color.f75c8025.svg";